import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const SessionWarningDialog: React.FC = () => {
  const { showSessionWarning, sessionExpiresIn, extendSession, signOut } = useAuth();

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}m ${secs}s`;
    }
    return `${secs}s`;
  };

  return (
    <Dialog
      open={showSessionWarning}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      aria-labelledby="session-warning-dialog"
    >
      <DialogTitle id="session-warning-dialog" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon color="warning" />
        Session Expiring Soon
      </DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Typography variant="body1" gutterBottom>
            Your session will expire due to inactivity.
          </Typography>
          <Typography variant="h4" color="error" sx={{ my: 2, fontWeight: 'bold' }}>
            {formatTime(sessionExpiresIn)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Click "Continue Session" to stay logged in, or you will be automatically logged out.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
        <Button onClick={signOut} color="inherit" variant="outlined">
          Logout Now
        </Button>
        <Button onClick={extendSession} color="primary" variant="contained" autoFocus>
          Continue Session
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionWarningDialog;
